import styled from "styled-components";
import { Loader } from 'semantic-ui-react';

export const Container = styled.div`
  padding: 1rem 1rem 5rem;
  margin-left: 250px;

  h1 {
    width: 100%;
    text-align: center;
  }
  h2 {
    text-align: left;
    width: 100%;
    padding: 1rem 0;
  }
  span{
    padding: 1rem 0 0 0 ;
  }
  th{
    color: #FFF!important;
  }
  
  `;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;
  
  button, a{
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }

  `;
export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content:flex-start;
  gap:1rem;
  flex-wrap: wrap;
  p {
    color: #232323;
    width: 100%;
    text-align:center;
  }
  /* border: 1px solid red; */
  `;

export const ContainerFilter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 1rem;
  div {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 1rem;
    span {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

    }
  }

`;
export const Box = styled.div`
  /* border: 1px solid var(1px solid rgba(34,36,38,.15)--color-primary); */
  padding: 2rem;
  border-radius: 1rem;
  background: ${props => props.color || "#222"};
  color: #FFF;
  width: 200px;
  height: 100px;
  p {
    font-size: 10px;
    padding: 0;
    margin: 0;
    font-weight: bold;
    color: #c6c6c6;
  }
`;
export const MainText = styled.h4`
  padding: 0;
  margin:0;
  font-size: ${props => props.isMinimal ? "18px!important" :"26px!important"};
  color:var(--color-primary);
  text-align:center;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
  `;

export const ButtonReset = styled.button`
  padding: 0.67857143em 1em;
  height: 35px;

  transition: color 0.1s ease, border-color 0.1s ease;
  box-shadow: 0 0 0 0 transparent inset;
  background: var(--color-primary);
  color: #FFF;
  border: none;
  cursor:pointer;
  border-radius: 10px;
  &:hover{
    background: var(--color-primary-dark);
  }

`;
export const SemanticLoader = styled(Loader)`

`;

export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;